module.exports = __webpack_public_path__ + "img/product3_banner.ede07882.png";